<script lang="ts">
  // This component has no inputs; the TypeScript block keeps generated component types explicit.
</script>

<div class="loading" role="status"><span aria-hidden="true"></span>Loading</div>

<style>
  .loading { display: flex; align-items: center; gap: .75rem; color: var(--muted); padding: 2rem 0; }
  span { width: 1rem; height: 1rem; border: 2px solid var(--line); border-top-color: var(--brand); border-radius: 50%; animation: spin .8s linear infinite; }
  @keyframes spin { to { transform: rotate(360deg); } }
  @media (prefers-reduced-motion: reduce) { span { animation: none; border-top-color: var(--line); } }
</style>
